import { createContext } from 'react';

const FilterContext = createContext({})

export  {FilterContext}
